// // @flow
import React from 'react';

const StructuredDataArticle = () => {
  const [structuredData, setStructuredData] = React.useState(null);

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const pageData = {
      url: window.location.href,
      title: document.title || 'Ansarada Article',
      description:
        document.querySelector("meta[name='description']")?.getAttribute('content') ||
        'No description available.',
      featuredImage:
        document.querySelector("meta[property='og:image']")?.getAttribute('content') || '',
      datePublished:
        document
          .querySelector("meta[property='article:published_time']")
          ?.getAttribute('content') || new Date().toISOString(),
      dateModified:
        document.querySelector("meta[property='article:modified_time']")?.getAttribute('content') ||
        new Date().toISOString(),
      language: document.documentElement?.lang || 'en-AU',
    };

    const structuredDataObject = {
      '@context': 'https://schema.org',
      '@type': 'Article',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': pageData.url,
      },
      headline: pageData.title,
      description: pageData.description,
      image: pageData.featuredImage ? [pageData.featuredImage] : [],
      author: {
        '@type': 'Person',
        name: 'Ansarada',
        url: 'https://www.ansarada.com/',
        image: 'https://static.ansarada.com/salesforce-email/AnsaradaLogo20X20.png',
        jobTitle: '',
        sameAs: [],
        worksFor: {
          '@type': 'Organization',
          name: 'Ansarada',
          url: 'https://ansarada.com',
          logo: 'https://static.ansarada.com/salesforce-email/AnsaradaLogo20X20.png',
        },
      },
      publisher: {
        '@type': 'Organization',
        name: 'Ansarada',
        url: 'https://ansarada.com',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.ansarada.com/images/logo.png',
        },
        sameAs: [
          'https://www.facebook.com/AnsaradaPlatform',
          'https://www.linkedin.com/company/ansarada',
          'https://www.instagram.com/ansarada_/?hl=en',
          'https://twitter.com/ansarada',
        ],
      },
      datePublished: pageData.datePublished,
      dateModified: pageData.dateModified,
    };

    setStructuredData(structuredDataObject);
  }, []);

  if (!structuredData) return null;

  return <script type="application/ld+json">{JSON.stringify(structuredData)}</script>;
};

export default StructuredDataArticle;
